import { render, staticRenderFns } from "./InfoBody.vue?vue&type=template&id=2416a869&scoped=true&lang=pug"
import script from "./InfoBody.vue?vue&type=script&lang=js"
export * from "./InfoBody.vue?vue&type=script&lang=js"
import style0 from "./InfoBody.vue?vue&type=style&index=0&id=2416a869&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2416a869",
  null
  
)

export default component.exports